<template>
  <AiEducationLayout>
  <ContentWrap>
    <el-form :inline="true" :model="query">
      <el-form-item label="学生">
        <el-select
          v-model="query.studentId"
          clearable
          filterable
          remote
          reserve-keyword
          :remote-method="searchStudents"
          placeholder="按姓名搜索学生"
          style="width: 200px"
        >
          <el-option
            v-for="item in students"
            :key="item.id"
            :label="item.nickname || item.name || item.mobile"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="课程">
        <el-select
          v-model="query.trainCourseId"
          clearable
          filterable
          placeholder="选择课程"
          style="width: 220px"
        >
          <el-option
            v-for="item in courses"
            :key="item.id"
            :label="item.title || item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="日期范围"
        ><el-date-picker v-model="dateRange" type="daterange" value-format="YYYY-MM-DD"
      /></el-form-item>
      <el-form-item>
        <el-button type="primary" @click="loadSummary">查询</el-button>
        <el-button
          v-hasPermi="['ai-education:analytics:export']"
          :loading="exporting"
          @click="exportExcel"
          >导出 Excel</el-button
        >
        <el-button
          v-hasPermi="['ai-education:analytics:export']"
          :loading="exporting"
          @click="exportPdf"
          >导出 PDF</el-button
        >
      </el-form-item>
    </el-form>
  </ContentWrap>
  <el-row :gutter="16" v-loading="loading">
    <el-col v-for="item in cards" :key="item.label" :xs="12" :sm="8" :lg="6">
      <ContentWrap
        ><div class="text-gray-500">{{ item.label }}</div
        ><div class="mt-8px text-24px font-600">{{ item.value }}</div></ContentWrap
      >
    </el-col>
  </el-row>
  <ContentWrap title="核心质量指标">
    <el-descriptions :column="2" border>
      <el-descriptions-item label="答题正确率">{{
        percent(summary.correctRate)
      }}</el-descriptions-item>
      <el-descriptions-item label="AI 拒答率">{{
        percent(summary.aiRefusalRate)
      }}</el-descriptions-item>
      <el-descriptions-item label="AI 请求数">{{ summary.aiRequests }}</el-descriptions-item>
      <el-descriptions-item label="AI 拒答数">{{ summary.aiRefusals }}</el-descriptions-item>
    </el-descriptions>
  </ContentWrap>
  </AiEducationLayout>
</template>

<script setup lang="ts">
import * as Api from '@/api/aiEducation'
import downloadUtil from '@/utils/download'
import { useBusinessOptions } from './useBusinessOptions'
import AiEducationLayout from './layout/AiEducationLayout.vue'

defineOptions({ name: 'AiEducationAnalytics' })
const loading = ref(false)
const exporting = ref(false)
const query = reactive<{ studentId?: number; trainCourseId?: number }>({})
const dateRange = ref<string[]>([])
const { courses, students, loadBaseOptions, searchStudents } = useBusinessOptions()
const summary = reactive<Api.AnalyticsSummaryVO>({
  studySeconds: 0,
  completedChapters: 0,
  quizAttempts: 0,
  correctAnswers: 0,
  wrongAnswers: 0,
  assignmentsSubmitted: 0,
  aiRequests: 0,
  aiRefusals: 0,
  correctRate: 0,
  aiRefusalRate: 0
})
const cards = computed(() => [
  { label: '学习时长', value: `${Math.round(summary.studySeconds / 60)} 分钟` },
  { label: '完成章节', value: summary.completedChapters },
  { label: '测验次数', value: summary.quizAttempts },
  { label: '提交作业', value: summary.assignmentsSubmitted }
])
const percent = (value?: number) => `${((value || 0) * 100).toFixed(1)}%`
const reportQuery = (): Api.AnalyticsQuery => ({
  ...query,
  startDate: dateRange.value?.[0],
  endDate: dateRange.value?.[1]
})
const loadSummary = async () => {
  loading.value = true
  try {
    Object.assign(summary, await Api.getAnalyticsSummary(reportQuery()))
  } finally {
    loading.value = false
  }
}
const exportExcel = async () => {
  exporting.value = true
  try {
    downloadUtil.excel(await Api.exportAnalyticsExcel(reportQuery()), 'AI教育学情报表.xlsx')
  } finally {
    exporting.value = false
  }
}
const exportPdf = async () => {
  exporting.value = true
  try {
    downloadUtil.pdf(await Api.exportAnalyticsPdf(reportQuery()), 'AI教育学情报告.pdf')
  } finally {
    exporting.value = false
  }
}
onMounted(async () => {
  await Promise.all([loadBaseOptions(), searchStudents()])
  await loadSummary()
})
</script>
